import MdIcon from "./MdIcon"

const MdIconPlugin = {
  install(app) {
    app.component(MdIcon.name, MdIcon)
  },
}

export default MdIconPlugin
